import { render, staticRenderFns } from "./GameRoomContainer.vue?vue&type=template&id=3ac21764&"
import script from "./GameRoomContainer.vue?vue&type=script&lang=js&"
export * from "./GameRoomContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports